const messages = {
  title: "Produktinformationen UND Freigaben",
  description:
    "Willkommen im Broschüren- und Preislistenbereich rund um die Produkte von Bridgestone und Firestone. Hier finden Sie aktuelle Broschüren und Preislisten zu allen Produktbereichen und Pricat Dateien für Ihre Warenwirtschaft.",
  productInfo: {
    index: {
      categories: {
        dataGenereate: {
          title: "Datenblatt-Generator",
          description: "IPC eintippen und eigenes Datenblatt generieren.",
        },
      },
    },
  },
  pricat: {
    title: "Pricat",
    description:
      "Laden Sie hier CSV- und TEXT- Datensätze für Ihre Warenwirtschafts- und EDV-Systeme & Co herunter.",
  },
};
export default {
  messages,
};
